import React, { useEffect, useState } from "react";
import axios from "axios";

const OffersOverlay = (props) => {
 	const [styleless, setStyleless]       = useState("");
 	const [cctLoading, setCctLoading]     = useState(false);
 	const [cctInfo, setCctinfo]           = useState([]);
 	const [cCount, setcCount]             = useState(true);

	const skipOffer2 = () => {
		if (cCount === true) {
			setcCount(false);
			props.ccT(8557, 1, props.CID, props.SID, props.isMobile);
			let first = document.querySelector('.first');		  
			let sec = document.querySelector('.second');
			first.classList && first.classList.toggle('hide');
			sec.classList && sec.classList.toggle('hide');
		} else {
			if( props.qs && (props.qs.skip === "pop" || props.qs.skip === "pop2") ){
            
				try {
					window.open( props.jobURL );
				} catch (e) {
				
				}
	
			}
			let offerIndex = props.offer.match(/(offerGoNextCount = "\d{1,2}")/g) //parse offer index from the returned html file
			offerIndex = offerIndex && offerIndex[0].split('"')[1];
			window.location = process.env['REACT_APP_API_URL'] + "/search/skipRP.fsn?CID="+props.CID+"&OFFER_IDX="+offerIndex;
		}
	}    

	useEffect(() => {
		let noStyle = props.offer.replace(/((<link(?! data-capture="0").*?>|<link>).*?)/g, '')
		setStyleless(noStyle);

		window.logOut = logOut;
		window.skipOffer = skipOffer;
		window.skipOffer2 = skipOffer2;
		window.trakClickSponsor = trakClickSponsor;
		window.lead5_trak = lead5_trak;
	}, [props.offer, cCount])

	const trakClickSponsor = (jID) => {
		let url = process.env['REACT_APP_API_URL'] + '/upward/jobclicktraker.jsp?JID=' + jID + '&provider=SPONSOR&OID=' + 727;
		let pixel = document.createElement("img");
		pixel.setAttribute('width', '0');
		pixel.setAttribute('src', url);
		pixel.setAttribute('height', '0');
		window.document.body.appendChild(pixel);
	}

	const lead5_trak = (link) => {
	  link.href = link.href+"&TRK=1";
	}

	const logOut = () => {
		axios.all([
            axios.get(process.env['REACT_APP_API_URL'] + "/upward/logout.jsp"),
        ])
        .then(responseArr => {
			document.location.reload();
        }, (error) => {
            console.log(error);
        });
	}

	const skipOffer = () => {
		setCctLoading(false);
		
		let offerIndex = props.offer.match(/(offerGoNextCount = "\d{1,2}")/g) //parse offer index from the returned html file
		offerIndex = offerIndex && offerIndex[0].split('"')[1];
		
		axios.get(process.env['REACT_APP_API_URL'] + "/search/skipRP.fsn?CID="+props.CID+"&OFFER_IDX="+offerIndex).then((response) => {
			document.querySelector("#offerLoad").classList.remove('in');
			if (response.data && !response.data.includes("window.top.location")) {
				props.setCurrentOffer(response.data);
				props.ccT(8557, 1, props.CID, props.SID, props.isMobile);
			} else {
				
			}
		}).catch(function (error) {
			console.log(error);
		})

	}

    return (
    	<>
			<div id="offerGoContainer">
			    <div id="offerGoDiv" dangerouslySetInnerHTML={{ __html: styleless }}></div>
			</div>
    	</>
    )
}

export default OffersOverlay;